import { Descriptions, Divider, Popover, Space, Tag, Typography } from "antd"
import React from "react"

const { Link } = Typography

export default function PriceDisplay(props) {
  const { data } = props

  const returnPrices = (prices, fixedPrices, fixed) => {
    const dynamicPriceCopy = Array.isArray(prices) ? [...prices] : []
    const fixedDynamicPriceCopy = Array.isArray(fixedPrices) ? [...fixedPrices] : []

    if (data.labelCount > 0) {
      const newPriceObject = {
        price: data.price,
        quantity: data.labelCount,
        id: Math.random().toString(),
      }

      dynamicPriceCopy.push(newPriceObject)
      fixedDynamicPriceCopy.push(newPriceObject)
    }

    // Check if advanced.fixedPrice is true and totalFixedPrice exists
    if (data.advanced.fixedPrice && data.totalFixedPrice) {
      fixedDynamicPriceCopy.push({
        price: data.totalFixedPrice,
        quantity: 1000, // Or any relevant quantity
        id: Math.random().toString(),
      })
    }

    if (fixed && Array.isArray(prices)) {
      return (
        <div style={{ width: 300 }}>
          <Space direction="vertical">
            <Divider>
              <Tag color="red">Fixed Prices</Tag>
            </Divider>
            {fixedDynamicPriceCopy.map((item) => (
              <Descriptions size="small" column={2} key={item.id}>
                <Descriptions.Item label="quantity">{item.quantity}</Descriptions.Item>
                <Descriptions.Item label="price">{item.price}</Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </div>
      )
    } else if (!fixed && Array.isArray(prices)) {
      return (
        <div style={{ width: 300 }}>
          <Space direction="vertical">
            <Divider>
              <Tag color="blue">Dynamic prices</Tag>
            </Divider>
            {dynamicPriceCopy.map((item) => (
              <Descriptions size="small" column={2} key={item.id}>
                <Descriptions.Item label="quantity">{item.quantity}</Descriptions.Item>
                <Descriptions.Item label="price">{item.price}</Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </div>
      )
    } else {
      return null
    }
  }

  const returnTapePrice = (priceArray, index) => {
    return (
      <div key={index} style={{ width: 300 }}>
        <Space direction="vertical">
          <Divider>
            <Tag color="green">Tape Prices</Tag>
          </Divider>

          {priceArray.map((item) => (
            <Descriptions size="small" column={3} key={item.id}>
              <Descriptions.Item label="rolls">{item.rolls}</Descriptions.Item>
              <Descriptions.Item label="boxes">{item.boxCount}</Descriptions.Item>
              <Descriptions.Item label="price">{item.price}</Descriptions.Item>
            </Descriptions>
          ))}
        </Space>
      </div>
    )
  }

  if (data.tapePrice) {
    return (
      <>
        <Popover content={() => returnTapePrice(data.prices)} placement="right" trigger="click">
          <Link onClick={() => console.log(data)}>Prices</Link>
        </Popover>
      </>
    )
  } else {
    return (
      <>
        <Popover
          content={() =>
            returnPrices(data.dynamicPrice, data.dynamicFixedPrice, data.advanced.fixedPrice)
          }
          placement="bottom"
          trigger="click">
          <Space>
            {/* <Link onClick={() => console.log(data)}>Prices</Link> */}
            {data.advanced.fixedPrice ? (
              <Tag color="red">fixed</Tag>
            ) : (
              <Tag color="blue">dynamic</Tag>
            )}
          </Space>
        </Popover>
      </>
    )
  }
}
